module.exports = __webpack_public_path__ + "static/media/microplating.f23fd2c5.png";